/**
 * @module Helper
 */

/**
 * Guard to ensure that a module is loaded only once in the application.
 *
 * This class prevents the accidental re-import of a module, which can lead to
 * unexpected behavior and errors. It should be used in the constructor of a module
 * to enforce singleton loading.
 *
 * @guard
 * @class EnsureModuleLoadedOnceGuard
 */
export class EnsureModuleLoadedOnceGuard {
	/**
	 * Creates an instance of the EnsureModuleLoadedOnceGuard.
	 *
	 * @constructor
	 * @param {any} targetModule - The module that is being checked for multiple imports.
	 * @throws {Error} Throws an error if the module has already been loaded.
	 */
	constructor(targetModule: any) {
		if (targetModule) {
			throw new Error(`${targetModule.constructor.name} has already been loaded. Import this module in the single place only.`);
		}
	}
}
